var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYtPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1945_16099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2491 3.74333C33.0541 3.01981 32.6737 2.36019 32.1457 1.83017C31.6178 1.30015 30.9608 0.918215 30.2401 0.7224C27.6017 0 16.9828 0 16.9828 0C16.9828 0 6.36334 0.0218666 3.72489 0.744267C3.00418 0.940093 2.34715 1.32205 1.81922 1.85209C1.29129 2.38214 0.910883 3.04178 0.715885 3.76533C-0.0821854 8.47173 -0.391771 15.6432 0.737799 20.1613C0.932817 20.8849 1.31323 21.5445 1.84116 22.0745C2.36909 22.6045 3.02611 22.9865 3.7468 23.1823C6.38525 23.9047 17.0044 23.9047 17.0044 23.9047C17.0044 23.9047 27.6234 23.9047 30.2618 23.1823C30.9825 22.9865 31.6395 22.6045 32.1675 22.0745C32.6954 21.5445 33.0759 20.8849 33.2709 20.1613C34.1127 15.4483 34.372 8.28133 33.2491 3.74347V3.74333Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6025 17.0746L22.4117 11.9522L13.6025 6.82983V17.0746Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1945_16099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtPlay);
export default __webpack_public_path__ + "static/media/yt-play.ed42827268c3c81ad0dee63645dcc891.svg";
export { ForwardRef as ReactComponent };